import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SalesRegHeader from "../../saleselements/SalesregHeader/SalesregHeader";
import DataTable from "../../saleselements/table/DataTable";
import SalesSideBar from "../../components/sales/SalesSideBar";
import commoncss from "../../css/common.module.css";
import DataState from "../../saleselements/common/DataState/DataState";
import ERPDataTable from "../../saleselements/table/ERPTable";

import { GetSale } from "../../../WorkSpace/Components/ApiServices/apiHandler";

const Listing = () => {
  const [showDataState, setShowDataState] = useState(true);
  const [tableType, setTableType] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
  const { id: routeSaleId } = useParams();
  const [saleID, setSaleID] = useState("");
  const handleFiltersApplied = (filters) => {
    setAppliedFilters(filters);
  };

  const handleNoDataFound = () => {
    setAppliedFilters([]);
  };

  useEffect(() => {
    if (routeSaleId) {
      setSaleID(routeSaleId);
      const savedTableType = sessionStorage.getItem(`tableType_${routeSaleId}`);
      if (savedTableType) {
        setTableType(savedTableType);
        setShowTable(true);
        setShowDataState(false);
      }
    } else {
      const fetchInitialSale = async () => {
        try {
          const response = await GetSale();
          const sales =
            response.data?.sales ||
            response.data?.Sale ||
            response.data?.result ||
            [];
          const saleArray = Array.isArray(sales) ? sales : [sales];
          if (saleArray.length > 0 && saleArray[0]) {
            const firstId =
              saleArray[0]._id || saleArray[0].id || saleArray[0].saleID;
            if (firstId) {
              setSaleID(firstId);
              const savedTableType = sessionStorage.getItem(`tableType_${firstId}`);
              if (savedTableType) {
                setTableType(savedTableType);
                setShowTable(true);
                setShowDataState(false);
              }
            }
          }
        } catch (error) {
          console.error("Failed to load initial sale ID:", error);
        }
      };
      fetchInitialSale();
    }
  }, [routeSaleId]);

  useEffect(() => {
    if (showTable && tableType === null) {
      const savedTableType = saleID
        ? sessionStorage.getItem(`tableType_${saleID}`)
        : null;
      setTableType(savedTableType || "excel");
    }
  }, [showTable, tableType, saleID]);

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <SalesSideBar activeTab={"Listing"} saleID={saleID} />
      <div
        className={`${commoncss.widthScrHidden} px-3 py-2`}
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        <SalesRegHeader
          saleID={saleID}
          setSaleID={setSaleID}
          setShowDataState={setShowDataState}
          tableType={tableType}
          setTableType={setTableType}
          setShowTable={setShowTable}
          appliedFilters={appliedFilters}
          onFiltersApplied={handleFiltersApplied}
          showAddRegisterModal={showAddRegisterModal}
          setShowAddRegisterModal={setShowAddRegisterModal}
        />

        {showDataState && !showTable && (
          <DataState 
            setShowAddRegisterModal={setShowAddRegisterModal}
          />
        )}

        {showTable && tableType === "excel" && (
          <DataTable
            filters={appliedFilters}
            SaleID={saleID}
            onNoDataFound={handleNoDataFound}
          />
        )}
        {showTable && tableType === "erp" && <ERPDataTable SaleID={saleID} />}
      </div>
    </div>
  );
};

export default Listing;